// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/_css-loader@3.6.0@css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bannerBox{width:100%}.bannerBox .banner{position:relative}.bannerBox .banner img{width:100%}.bannerBox .banner .bgBottom{position:absolute;bottom:0;z-index:99}", ""]);
// Exports
module.exports = exports;
